import React from 'react';
import { takeEvery, put, call } from 'redux-saga/effects';
import { setWorkspaceCollaborators } from 'Workspace/Admin/store/actions';
import { FormattedMessage } from 'react-intl';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { workspaceId } = action;

  const workspaceCollaboratorsSummary = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_COLLABORATOR_SUMMARY,
    workspaceId,
  });

  if (workspaceCollaboratorsSummary.type === constants.RTM_WORKSPACE_COLLABORATOR_SUMMARY_OK) {
    const workspaceCollaborators = workspaceCollaboratorsSummary.response.collaborators;
    yield put(setWorkspaceCollaborators(workspaceId, workspaceCollaborators));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspaceCollaboratorsSummary} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_COLLABORATOR_SUMMARY, catchErrors, sendRequest, connection);
}
